import angular from 'angular';
import 'angular-ui-router'
import 'angular-sanitize'
import './lib/jquery/jquery-ui.min'
import './lib/bootstrap/bootstrap.min'
import './lib/draggabilly.pkgd.min'
import './lib/lodash/lodash.min'
import './lib/tooltips/angular-tooltips.min'
import './lib/ngModules/ng-tags/ng-tags-input.min'
import './lib/ngModules/ng-file-upload/ng-file-upload.min'
import './lib/ngModules/ng-crop/ng-img-crop'
import './lib/fullcalendar/fullcalendar.min'
import 'datatables.net'
import 'datatables.net-bs'
import './lib/ngModules/anguComplete/angucomplete-alt.min'
import './lib/ngModules/moment-picker/angular-moment-picker.min'
import './lib/jquery-touch-punch/jquery.ui.touch-punch.min'
import './lib/ui-bootstrap-tpls.min'

const rootElement = angular.element(document.body);

// Ensure AngularJS destroys itself on hot reloads.
const oldInjector = rootElement.injector();
if (oldInjector) {
  oldInjector.get('$rootScope').$destroy();
  rootElement.data('$injector', null);
}
